import { createSelector } from 'reselect';

const selectRouter = (state) => state.router;

const makeSelectLocation = () =>
  createSelector(selectRouter, (routerState) => routerState.location);

export { makeSelectLocation };
